import * as React from 'react';

// Utils
import cx from 'classnames';

// Assets
import IconNotFound from '../Icons/IconNotFound';

// Styles
import styles from './style.scss';

type Props = {
  icon?: React.ComponentType<any>;
  title: string;
  titleClassName?: string;
  subtitle?: string;
  subtitleClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  actionButton?: React.ReactNode;
};

function NotFound({
  icon: Icon = IconNotFound,
  title,
  titleClassName,
  subtitle,
  subtitleClassName,
  className = '',
  style = {},
  actionButton,
}: Props): JSX.Element {
  return (
    <div className={cx(styles.content, className)} style={style}>
      <Icon className={styles.icon} />
      <div className={cx(styles.title, titleClassName)}>{title}</div>
      <div className={cx(styles.subTitle, subtitleClassName)}>{subtitle}</div>
      {actionButton}
    </div>
  );
}

export default NotFound;
